module.exports = __webpack_public_path__ + "static/media/messages_icon.ed5fdfca.svg";